var _style, _path, _path2, _line, _line2, _path3, _path4, _path5, _path6, _path7, _path8, _line3, _path9, _line4, _path10, _line5, _path11, _line6, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoEcoleZero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x30_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 487.3 391.7",
    style: {
      enableBackground: "new 0 0 487.3 391.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:8;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.4,58.4c-2-2.3-3.5-3.7-4.5-5.3C191.6,40,181.7,28.6,168.8,20c-3.1-2.1-4.8-2.5-6.5,1.2 c-4.5,9.7-9.1,19.2-13.6,28.9c-4.4,9.4-8.6,18.9-13.1,28.9C116.9,66.4,99,51.7,77.4,43.3c-1.2,12.2-2.8,23.7-3.5,35.2 c-0.7,10.1-0.6,20.3-0.8,30.5c-0.1,3.4-1.6,4.6-4.9,4.7c-3.6,0.1-7.3,0.8-10.9,1.5c-15.2,2.7-30.4,5.5-45.5,8.2 c-1.7,0.3-3.4,0.7-6.1,1.2c2.3,2.9,3.9,5.2,5.7,7.2c8.9,9.8,18.1,19.4,26.9,29.3c10.2,11.5,20.1,23.4,30.4,34.9 c2.8,3.2,2.1,5.4-1.2,7c-3.7,1.8-7.9,2.7-11.4,4.7c-11,6.4-21.7,13.1-33.4,20.2c5.7,4.5,11.6,9.3,17.6,13.7 c5.8,4.2,12,7.8,17.7,12.1c11.9,9,23.6,18.2,35.3,27.5c1.4,1.1,2.9,3.7,2.5,5.1c-3.8,13.8-7.9,27.5-12.1,41.1 c-2.2,7.2-4.9,14.3-7.4,21.5c0.3,0.4,0.6,0.9,0.9,1.3c3.2-1.3,6.6-2.3,9.7-4c12.1-6.7,23.9-13.6,36-20.3c7.8-4.3,15.9-8.2,23.8-12.4 c2.8-1.5,4-0.5,4.6,2.3c1.8,8.3,3.7,16.5,5.4,24.9c1.6,7.7,3,15.5,4.7,24.1c2.3-1.1,3.7-1.7,5.1-2.5c17.1-9.6,34.2-19.3,51.3-28.8 c1.4-0.8,4.1-1.2,5.1-0.4c6.5,5.1,12.8,10.5,19.1,16c13,11.4,25.8,22.8,38.7,34.2c1.2,1.1,2.5,2,3.7,2.8c23.4-25.3,41.5-54,59.5-84 c19.8,17.1,39.2,33.9,61.6,46.4c0-10.4,0.4-20.4-0.1-30.2c-0.7-12.8-2-25.5-3.2-38.3c-0.3-3.6,0.4-5.4,4.6-6.5 c17.2-4.3,34.3-9.2,51.4-14.1c7.4-2.1,14.7-4.7,23.5-7.5c-7.1-5.8-13.3-11.1-19.9-16c-8.1-6-16.5-11.6-24.6-17.6 c-4.7-3.4-9-7.4-13.6-10.8c-3.7-2.6-7.7-4.8-12.9-7.9c3.6-1.3,6.2-2.8,9-3.2c18.2-2.6,35.7-7.9,53.3-13.1c0.6-0.2,1.1-0.5,2.5-1.2 c-2.5-2.1-4.4-3.7-6.4-5.4c-1.5-1.3-3.2-2.4-4.6-3.8c-4.2-4.2-8-8.9-12.4-12.7c-11.9-10.3-24.1-20.3-36.3-30.2 c-2.6-2.1-2.6-3.7-1.2-6.3c5.5-10.4,10.9-20.9,16.3-31.4c2.9-5.5,5.7-11,9-17.3c-11.1,0-21.1-0.3-31,0.1 c-10.1,0.4-20.2,1.4-30.4,1.9c-1.6,0.1-4-1.1-4.8-2.4c-2.2-3.7-3.6-7.8-5.4-11.7c-6-12.7-9.9-26.4-19.3-37.5c-3-3.5-4.7-4.2-8.2-1.2 c-11.2,9.6-22.7,18.9-33.9,28.5c-8.6,7.3-17,14.9-25.4,22.3c-5.7,5-11.3,9.9-17,14.9c-0.5-0.2-1-0.4-1.4-0.7 c-2.3-27.8-4.5-55.6-6.8-83.3c-0.6-0.1-1.2-0.1-1.8-0.2C237.8,23,221.4,40.4,204.4,58.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114,136.5c0,0,14,1.5,16.2,1.3c2.2-0.2,15.8-3.1,18.5-2.7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 120.3,
    y1: 125,
    x2: 142.2,
    y2: 109.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 107.4,
    y1: 161.9,
    x2: 137.4,
    y2: 163.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109,192.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114,136.5c0,0-6.9,53.2-5,54.7c1.8,1.5,7.3,3.1,7.3,3.1l28.5,2.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.8,135.1c0,0-35-9.2-41.5,29.7s36.2,34.6,40.3,22.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.3,142.9c9.2,0.1,30.6,6.1,22,29.6s-20.2,27.3-37.9,21.8c-17.7-5.5-13.1-29.9-10-35.8 S239.2,142.7,258.3,142.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337,192.9c0,0-12.7,2.4-18.9,2.9c-6.3,0.4-15.4-1.6-15.4-1.6s-4-42.9-3.5-49.2s0-17.1,0-17.1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379,133l-27.5,1.2c0,0-6.6,49.4-4,53.4c0,0,13.8,4.3,17.4,4.5c12.7,0.7,20.2,0,20.2,0"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 344.2,
    y1: 163.6,
    x2: 379,
    y2: 161.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,285.6c0,0-22.9-1.3-27.4-2.4s-21.6-5-21.6-5l41.6-62.1c-15.4,2.5-39.1,2.3-39.1,2.3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 229.5,
    y1: 254,
    x2: 198.4,
    y2: 254
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.1,224.7c0,0-15.1,0.9-18.6,2.5s-16,2.7-16,2.7s-3.7,50.8-1.2,55.8l34.3,1.2"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 211,
    y1: 216.2,
    x2: 230.5,
    y2: 199.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.8,282.3v-65.5c0,0,25.7-4.5,25.9,14.5s-14.9,21.4-30.8,22.7"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 296.2,
    y1: 284.7,
    x2: 267.9,
    y2: 252.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337,223.6c11.8,0.1,28.1,9.1,23.1,33.2s-26.6,21.3-33.7,21.2s-25.2-14.1-18.2-32.5S320.9,223.5,337,223.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEcoleZero);
export default __webpack_public_path__ + "static/media/logoEcoleZero.65583b34daeb3e988ea0af2732900581.svg";
export { ForwardRef as ReactComponent };